import { twMerge } from 'tailwind-merge';

import Text from '@/components/ui/custom/dataDisplay/Text';
import Skeleton from '@/components/ui/custom/Skeleton';

interface StatisticsCardProps {
  title: string;
  info: string | number;
  isLoading?: boolean;
  className?: string;
  testId?: string;
  size?: 'small' | 'regular';
}

export default function StatisticsCard(props: StatisticsCardProps) {
  const { className, info, title, isLoading, testId, size } = props;

  let text: string | number;

  if (typeof info === 'number') {
    text = Number.isInteger(info) ? info : info.toFixed(2);
  } else {
    text = info;
  }

  const cardSize =
    size === 'small'
      ? 'px-3 xl:px-4 py-1.5 aspect-[5.7] xl:aspect-[4.9] h-9 xl:h-12 text-14 xl:text-16'
      : 'flex-col aspect-[2/1.5] w-full h-full px-2 py-6 justify-center gap-1';

  return (
    <div
      data-testid={testId}
      className={twMerge(
        'flex bg-base-100 text-secondary rounded-2xl shadow-default w-auto justify-between items-center',
        cardSize,
        className,
      )}
    >
      <Text text={title} format="rubik-500" className="uppercase text-center" />
      {isLoading ? (
        <Skeleton className="bg-accent/40 rounded-xl w-6 h-4" />
      ) : (
        <Text format="rubik-500" text={text} className="text-base-content" />
      )}
    </div>
  );
}
